'use client';

import { AiOutlineArrowUp } from 'react-icons/ai';
import Link from 'next/link';
import { useTranslate } from '@tolgee/react';

import { AuthErrorTemplate } from '~/app/templates/AuthError';

export const metadata = {
  title: '404 | Page not found',
};

export default function NotFoundPage() {
  const { t } = useTranslate();

  return (
    <AuthErrorTemplate>
      <p className="mb-2 text-sm leading-tight">
        {t('common.not_found.404')}
      </p>

      <Link href="/home">
        <span className="border-b border-[#0053ad] text-xs font-semibold text-[#0053ad]">
          <AiOutlineArrowUp style={{ transform: 'rotate(-45deg)' }} />{' '}
          {t('common.not_found_redirect_message')}
        </span>
      </Link>
    </AuthErrorTemplate>
  );
}
